import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Subscribe from "../../APIController/Subscribe";

const SubscriptionHandler = ({ success = false }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { finaliseSubscription } = Subscribe();

    useEffect(() => {
        const handleFinalize = async () => {
            if (!success) return;

            // URL-Parameter auslesen
            const params = new URLSearchParams(location.search);
            const sessionId = params.get("session_id");
            const workspaceId = params.get("workspace_id");
            const planId = params.get("plan_id");

            if (!sessionId || !workspaceId || !planId) {
                console.error("Missing sessionId or workspaceId in URL");
                return;
            }

            try {
                await finaliseSubscription(sessionId, planId);

                navigate("/app/dashboard");
            } catch (err) {
                console.error("Error finalizing subscription:", err);
                navigate("/app/dashboard");
            }
        };

        handleFinalize();
    }, [location.search, success, finaliseSubscription, navigate]);

    return (
        <div>
            <h1>Subscription Handler</h1>
            {success ? <p>Finalizing subscription...</p> : <p>Subscription was cancelled or failed.</p>}
        </div>
    );
};

export default SubscriptionHandler;
